module.exports = __webpack_public_path__ + "10f8c87a149f0c46b42aaca895599b3e.gif";